import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import NowSecureCredentialsForm from './NowSecureCredentialsForm';
import NowSecureMappingForm from './NowSecureMappingForm';

const NowSecureConfigListing = (props) => (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={NowSecureMappingForm}
        CredentialsForm={NowSecureCredentialsForm}
        componentName="Project"
        componentKey="applicationName"
     />
);

export default NowSecureConfigListing;
